import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'

import AccountTooltipController from './dashboard/AccountTooltipController'

const Header = () => (
  <Box className='header' sx={{flexGrow: 1}}>
    <AppBar position='static'>
      <Toolbar>
        <Typography color='text.primary' variant='h4' sx={{flexGrow: 1, textDecoration: 'none'}}>Accounts</Typography>
        <AccountTooltipController />
      </Toolbar>
    </AppBar>
  </Box>
)

export default Header
